<template>
	<div>
		<b-container fluid>
			<b-row>
				<b-col class="text-center">
                    <svg class="loader" height="60" width="60">
                        <circle class="loader-ring-bkg" stroke="#e0e0e0" stroke-width="4" fill="transparent" r="25" cx="30" cy="30"></circle>
                        <circle class="loader-ring" stroke="#3486B8" stroke-width="5" fill="transparent" r="25" cx="30" cy="30"></circle>
                    </svg>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
export default {
	name: 'Login',
	components: {
        
    },
    beforeCreate: function() {
        document.body.className = 'main';
    },
	mounted(){
        var self = this;
		const loadConfig=(ip)=>{
            console.log("LOADING "+ip);
			var url = '/config.json?t='+Date.now();
			if(ip){
				url = 'https://'+ip+'/config.json?t='+Date.now();
			}
			fetch(url, {
				headers : { 
					'Content-Type': 'application/json;charset=utf-8',
					'Accept': 'application/json'
				}
			})
			.then(function(response){
				return response.json();
			}).then((data) => {
                console.log("CONFIG LOADING DONE ");

				//data.disconnection_time = 180;
				
				self.$root.disconnection_time = data.disconnection_time;
				self.$root.reload_duration = data.reload_duration * 1000;

				self.$session.set('app_name', data.name);
				self.$session.set('app_version', data.version);

				self.$session.set('weburl', 'https://'+data.ip);
				if(data.apiport != null){
					self.$session.set('apiurl', 'https://'+data.ip+':'+data.apiport+'/');
				}else{
					self.$session.set('apiurl', 'https://'+data.ip+':3004/');
				}
				
				self.$session.set('location', data.location);
				self.$session.set('webport', data.port);

				self.$session.set('disconnection_time', data.disconnection_time);

				self.$root.app_name = data.name;
				self.$root.app_version = data.version;
				
                self.loading = false;
                
                
                if(self.$session.get('access_key') == "" || self.$session.get('access_key') == null){
                    self.$router.push('/login');
                }else{
                    var user_info = self.$session.get('user_info');
					if(user_info.permissions.dashboard_link){
						self.$router.push(user_info.permissions.dashboard_link);
					}else{
						self.$router.push('/dashboard');
					}
                }
			});
		}

		if(location.host.split(":")[0] == 'localhost' && (location.host.split(":")[1] == 8080 || location.host.split(":")[1] == 8081)){
			//loadConfig('103.211.219.169'); // macs
			//loadConfig('216.10.251.190'); //Maharastra

			
			//loadConfig('103.211.219.21'); //'216.10.251.190 // 103.211.218.36' //216.10.245.169 //103.211.219.21(Jhanshi)
  

			/* ============================== For Jhanshi ===================== */
			//var urlPost = 'http://103.211.219.21';
			var urlPost = 'https://gorakhpur.ccms.live';
			self.$root.disconnection_time = 1440;
				self.$root.reload_duration = 30 * 1000;
				self.$session.set('app_name', 'GORAKPUR STREET LIGHT CCMS');
				self.$session.set('app_version','ver-2.1');
				self.$session.set('weburl', urlPost);				
				self.$session.set('apiurl', urlPost+':3004/');						
				self.$session.set('location', 'jhansi');
				self.$session.set('webport', '32255');
				self.$session.set('disconnection_time', 1440);

				self.$root.app_name = 'GORAKPUR STREET LIGHT';
				self.$root.app_version = 'ver-2.1';
				
                self.loading = false;

			if(self.$session.get('access_key') == "" || self.$session.get('access_key') == null){
                    self.$router.push('/login');
                }else{
                    var user_info = self.$session.get('user_info');
					if(user_info.permissions.dashboard_link){
						self.$router.push(user_info.permissions.dashboard_link);
					}else{
						self.$router.push('/dashboard');
					}
                }
				/* ================================================================== */
		}else{
            loadConfig('');
		}
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'jhansiapi/dashboard'
		};
	},
	methods: {
	}
}
</script>
<style>

:root {
  --loaderCirc: 157.08;
}

@keyframes loader-spin {
  100% {
    stroke-dashoffset: -157.08;
    transform: rotate(270deg);
  }
}
svg.loader .loader-ring {
    stroke-dasharray: var(--loaderCirc);
    stroke-dashoffset: var(--loaderCirc);
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
    animation: 2s loader-spin forwards linear infinite;
}


html{
	min-height: 100%;
}
body.main{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 100vh;
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
.info-box2{
	display: block;
	min-height: 90px;
	background-color: #FFF;
	width: 100%;
	box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	border-radius: 2px;
    margin-bottom: 15px;
}

</style>